// Module
var code = "<abx-work-order-list class=\"flat\" abx-building=\"vm.building\" abx-models=\"vm.workOrders\" abx-fetch=\"vm.fetchWorkOrders(skip, limit)\" abx-fetch-all=\"vm.fetchAllWorkOrders(limit)\" abx-status=\"vm.status\"> </abx-work-order-list> ";
// Exports
module.exports = code;